<template>
    <b-overlay :show="pdfLoading" rounded opacity="0.6" spinner-small spinner-variant="primary" class="d-inline-block">
        <b-button variant="custom-outline-secondary" class="fs-14 mt-2" size="sm" @click="downloadPDF"> Скачать печатную форму предложения </b-button>
    </b-overlay>
</template>

<script>
import FileDownload from 'js-file-download';

export default {
    name: 'private-download-proposal-pdf-button',
    props: {
        purchaseId: {
            type: Number,
            required: true
        },
        proposalId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            pdfLoading: false
        };
    },
    methods: {
        downloadPDF() {
            this.pdfLoading = true;
            this.$api.products.fl223.purchases
                .downloadProposalPDF(this.purchaseId, this.proposalId)
                .then((response) => {
                    const regExpFilename = /filename="(?<filename>.*)"/;
                    const regExpFilename1 = /filename=(?<filename>.*)/;
                    const fileName = regExpFilename.exec(response['headers']['content-disposition'])?.groups?.filename ?? regExpFilename1.exec(response['headers']['content-disposition'])?.groups?.filename;
                    FileDownload(response.data, fileName);
                })
                .catch((error) => {
                    this.showError(error);
                })
                .finally(() => {
                    this.pdfLoading = false;
                });
        }
    }
};
</script>
